import { IUser } from "./../entities/user/index";
import { useSelector } from "react-redux";
import { io, Socket } from "socket.io-client";
import { AppDispatch } from "../store";
import {
  userJoined,
  topicStarted,
  questionTimerEnded,
  questionAnswered,
  questionAnswerValidated,
  errorOccurred,
  setCurrentQuestion,
  topicCompleted,
  userLeft,
  questionAnswersSubmitted,
} from "../reducers/topic";
import { authRepository } from "../repositories/auth-repository";

let socket: Socket | null = null;

export const connectWebSocket = (dispatch: AppDispatch) => {
  const token = localStorage.getItem("token");
  const user = authRepository.getUserFromStorage();
  if (!token) {
    console.warn("⚠️ No token found, skipping WebSocket connection.");
    return;
  }

  if (socket && socket.connected) return;

  socket = io("wss://topic-stg-api.pyxizhub.com/", {
    transports: ["websocket"],
    auth: { token },
    reconnection: true,
    // reconnectionAttempts: 10,
    // reconnectionDelay: 1000,
    // timeout: 20000,
  });

  socket.on("connect", () => console.log("✅ WebSocket connected"));

  socket.on("disconnect", (reason) => {
    console.warn(`⚠️ WebSocket disconnected: ${reason}`);
    socket = null;
  });

  socket.on("connect_error", (error) => {
    console.error("❌ WebSocket connection error:", error);
  });

  socket.onAny((event, data) => {
    console.log(`📡 Event Received: ${event}`, data);
    switch (event) {
      case "topic:user:joined":
        dispatch(userJoined(data));
        break;
      case "topic:user:left":
        dispatch(userLeft(data));
        break;
      case "topic:question:new":
        dispatch(setCurrentQuestion(data));
        break;
      case "topic:started":
        dispatch(topicStarted(data));
        break;
      case "topic:question:timer:ended":
        dispatch(questionTimerEnded(data));
        break;
      case "topic:question:answered":
        dispatch(questionAnswered({ ...data, userId: user?.id }));
        break;
      case "topic:question:answer:validated":
        dispatch(questionAnswerValidated(data));
        break;
      case "topic:question:answers:submitted":
        dispatch(questionAnswersSubmitted(data));
        break;
      case "topic:completed":
        dispatch(topicCompleted(data));
        break;
      case "error":
        dispatch(errorOccurred(data.error));
        break;
      default:
        console.warn(`⚠️ Unhandled event: ${event}`);
    }
  });
};
export const sendWebSocketEvent = (event: string, data: any) => {
  if (socket && socket.connected) {
    socket.emit(event, data);
  } else {
    console.warn("⚠️ WebSocket is not connected.");
  }
};
